import { Brand, TrustLogo } from "@/core/types/types";

const TRUST_LOGOS: {
  [key in keyof typeof Brand as string]: TrustLogo[];
} = {
  [Brand.CHEVALIER]: [
    {
      logo: "tuev.svg",
      width: 100,
      height: 64,
    },
  ],
};

export default function getTrustLogosForBrand(brandName: Brand): any {
  return { logos: TRUST_LOGOS[brandName], gap: 1 };
}
